<template>
  <v-select
    :items="filteredList"
    :label="label"
    :value="data"
    item-value="id"
    item-text="name"
    clearable
    :disabled="disabled"
    @input="$emit('change', $event)"
  >
    <template v-if="search" #prepend-item>
      <div class="pr-4 pl-4 pb-2">
        <v-text-field
          hide-details
          :loading="searchIsLoading"
          :label="searchLabel"
          :disabled="disabled"
          @input="onSearch($event)"
        />
      </div>
    </template>
    <template v-if="filteredList && filteredList.length" #item="{ item }">
      <div class="d-inline-flex align-center">
        <v-img :src="item.file.path" class="mr-2" width="32" height="32" />
        {{ item.name }}
      </div>
    </template>
    <template v-if="filteredList && filteredList.length" #selection="{ item }">
      <div class="d-inline-flex align-center">
        <v-img :src="item.file.path" class="mr-2" width="24" height="24" />
        {{ item.name }}
      </div>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'icon-select-component',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
    data: Object,
    label: String,
    useLocalFilter: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    searchLabel: {
      type: String,
      default: null,
    },
    searchIsLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    searchData: '',
  }),
  computed: {
    filteredList() {
      if (!this.searchData) return this.list;
      return this.list.filter((item) => item.name
        .toLowerCase().indexOf(this.searchData?.toLowerCase()) !== -1);
    },
  },
  methods: {
    onSearch(event) {
      this.searchData = event;
    },
  },
};
</script>
